import { OneTime } from '../OneTime';

export const Price = () => {
  return <OneTime />;
};
